<div class="wrapper-header">
  <div class="header-logo">
    <img src="../../../../assets/images/landing/icon-r.svg" alt="">
  </div>
  <div class="wrapper-pages-link">
    <div class="item-header" [routerLink]="[PAGES_AND_PATHS.landingHome.pagePath]" routerLinkActive="active">
      <span>Početna</span>
      <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
    </div>
    <div class="item-header" [routerLink]="[PAGES_AND_PATHS.landingAboutUs.pagePath]" routerLinkActive="active">
      <span>O nama</span>
      <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
    </div>
    <div class="item-header" [routerLink]="[PAGES_AND_PATHS.landingBlog.pagePath]" routerLinkActive="active">
      <span>Blog</span>
      <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
    </div>
    <div class="item-header" [routerLink]="[PAGES_AND_PATHS.landingForBusinesses.pagePath]" routerLinkActive="active">
      <span>Za biznise</span>
      <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
    </div>
    <div class="item-header" [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" routerLinkActive="active">
      <span>Kontakt</span>
      <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
    </div>
  </div>
  <button class="custom-btn custom-btn--primary" [routerLink]="[PAGES_AND_PATHS.login.pagePath]">
    <span>Prijavi se</span>
  </button>
</div>
